const {
  VITE_API_URL: API_URL,
  VITE_GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID,
  VITE_RELEASE_VERSION: RELEASE_VERSION,
  VITE_RUDDERSTACK_DATA_PLANE_URL: RUDDERSTACK_DATA_PLANE_URL,
  VITE_RUDDERSTACK_WRITE_KEY: RUDDERSTACK_WRITE_KEY,
  VITE_SENTRY_DSN: SENTRY_DSN,
  VITE_SPLIT_API_KEY: SPLIT_API_KEY,
  VITE_WS_URL: WS_URL
} = import.meta.env;

const PROD = window.location.hostname.includes('pulse.prizepicks.com');

export {
  API_URL,
  GOOGLE_CLIENT_ID,
  PROD,
  RELEASE_VERSION,
  RUDDERSTACK_DATA_PLANE_URL,
  RUDDERSTACK_WRITE_KEY,
  SENTRY_DSN,
  SPLIT_API_KEY,
  WS_URL
};
